export default {
  'From account': 'From account',
  'To account': 'To account',
  transfer: 'Transfer {{amount}}',
  'Money transfer': 'Money transfer',
  transferId: 'Transfer ID: {{id}}',
  'Transfer done': 'Transfer done',
  'Credit amount': 'Credit amount',
  LIMIT_REACHED: 'Limit reached',
  NOT_SUFFICIENT_FUNDS: 'Not sufficient funds',
};
